export class RoadColors {
  static YELLOW = '#FFCB02';
  static ORANGE = '#F17D00';
  static RED = '#FF0000';
  static PURPLE = '#9900FF';
}